/*
 * Canonical hover-lift for clickable card-like surfaces.
 * Apply to any Paper/Card/UnstyledButton tile that is interactive (Link/button/onClick).
 * Card gets it for free via theme defaults; non-Card surfaces opt in by className.
 */
.interactiveSurface {
  transition: transform 250ms cubic-bezier(0.4, 0, 0.2, 1),
              box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

.interactiveSurface:hover {
  /*
   * Works now that Paper/Card paint their resting shadow via the `shadow` prop (Mantine's
   * own class rule) rather than an inline style: this `:hover` rule (0,2,0) overrides that
   * class rule (0,1,0) by specificity. Also applies directly to shadow-less tiles
   * (UnstyledButton/Box).
   */
  box-shadow: var(--hm-shadow-card-hover);
  transform: translateY(-4px);
}

@media (prefers-reduced-motion: reduce) {
  .interactiveSurface,
  .interactiveSurface:hover {
    transition: none;
    transform: none;
  }
}

.buttonElevated {
  box-shadow: var(--hm-shadow-button-base);
}

.buttonElevated:hover:not(:disabled) {
  box-shadow: var(--hm-shadow-button-hover);
  transform: translateY(-2px);
}

.buttonElevated:active:not(:disabled) {
  box-shadow: var(--hm-shadow-button-active);
  transform: translateY(0);
}

.buttonFlat {
  box-shadow: none;
}

.buttonFlat:hover:not(:disabled) {
  box-shadow: none;
  transform: none;
}

.actionIconRoot:active {
  transform: scale(0.95);
}

.inputRoot:focus {
  box-shadow: var(--hm-shadow-input-focus);
}

.inputPrimaryFocus:focus {
  border-color: var(--mantine-primary-color-6);
}

:global(.mantine-Input-input:focus) {
  border-color: var(--mantine-primary-color-6);
  box-shadow: var(--hm-shadow-input-focus);
}

.anchorRoot:hover {
  text-decoration: underline;
}
